<template>
 
<div class="image-container">
      <img :src="currentImage" />
</div>
</template>

<script>
export default {
  props: {
      areaId: {
        type: Number,
        required: false,
      },
    },
    data() {
    return {
      currentImage: '',
      intervalId: null, 
    };
  },
  methods: {
    loadNewImage() {
      //console.log('log image');
      const timestamp = new Date().getTime(); 
      this.currentImage = '/MayImage/snapshot.png?t='+timestamp;
      //console.log(this.currentImage);
    },
    startImageRefresh() {
      this.intervalId = setInterval(this.loadNewImage, 3000);
    },
    stopImageRefresh() {
      if (this.intervalId) {
        clearInterval(this.intervalId); 
      }
    },
  },
  mounted() {
    this.loadNewImage(); 
    this.startImageRefresh(); 
  },
  beforeDestroy() {
    this.stopImageRefresh(); 
  },
};
</script>
<style>

.flex {
  height: 800px;           
  width:450px;
  display: flex;
  justify-content: center;
  
}

.image-container {
  display: flex;
  justify-content: center; 
  align-items: flex-start; 
  height: 60vh; 
  width:100vw;
}

img {
  max-width: 40%; /* Responsive width */
  height: auto; /* Maintain aspect ratio */
}

</style>